/* eslint-disable */
// NOTE: this file is autogenerated - do not change it manually!
export default {
  add: () =>
    import(
      /* webpackChunkName: "icon-add" */ '/@/core/elements/icons/svgs/add.vue'
    ),
  arrow: () =>
    import(
      /* webpackChunkName: "icon-arrow" */ '/@/core/elements/icons/svgs/arrow.vue'
    ),
  arrowCurvy: () =>
    import(
      /* webpackChunkName: "icon-arrowCurvy" */ '/@/core/elements/icons/svgs/arrowCurvy.vue'
    ),
  assetReplace: () =>
    import(
      /* webpackChunkName: "icon-assetReplace" */ '/@/core/elements/icons/svgs/assetReplace.vue'
    ),
  assets: () =>
    import(
      /* webpackChunkName: "icon-assets" */ '/@/core/elements/icons/svgs/assets.vue'
    ),
  badge: () =>
    import(
      /* webpackChunkName: "icon-badge" */ '/@/core/elements/icons/svgs/badge.vue'
    ),
  bestValue: () =>
    import(
      /* webpackChunkName: "icon-bestValue" */ '/@/core/elements/icons/svgs/bestValue.vue'
    ),
  bookmark: () =>
    import(
      /* webpackChunkName: "icon-bookmark" */ '/@/core/elements/icons/svgs/bookmark.vue'
    ),
  bookmarkFull: () =>
    import(
      /* webpackChunkName: "icon-bookmarkFull" */ '/@/core/elements/icons/svgs/bookmarkFull.vue'
    ),
  books: () =>
    import(
      /* webpackChunkName: "icon-books" */ '/@/core/elements/icons/svgs/books.vue'
    ),
  'brand-discounts': () =>
    import(
      /* webpackChunkName: "icon-brand-discounts" */ '/@/core/elements/icons/svgs/brand-discounts.vue'
    ),
  briefcase: () =>
    import(
      /* webpackChunkName: "icon-briefcase" */ '/@/core/elements/icons/svgs/briefcase.vue'
    ),
  brushMinus: () =>
    import(
      /* webpackChunkName: "icon-brushMinus" */ '/@/core/elements/icons/svgs/brushMinus.vue'
    ),
  brushPlus: () =>
    import(
      /* webpackChunkName: "icon-brushPlus" */ '/@/core/elements/icons/svgs/brushPlus.vue'
    ),
  bug: () =>
    import(
      /* webpackChunkName: "icon-bug" */ '/@/core/elements/icons/svgs/bug.vue'
    ),
  calendar: () =>
    import(
      /* webpackChunkName: "icon-calendar" */ '/@/core/elements/icons/svgs/calendar.vue'
    ),
  camera: () =>
    import(
      /* webpackChunkName: "icon-camera" */ '/@/core/elements/icons/svgs/camera.vue'
    ),
  cardview: () =>
    import(
      /* webpackChunkName: "icon-cardview" */ '/@/core/elements/icons/svgs/cardview.vue'
    ),
  cart: () =>
    import(
      /* webpackChunkName: "icon-cart" */ '/@/core/elements/icons/svgs/cart.vue'
    ),
  caution: () =>
    import(
      /* webpackChunkName: "icon-caution" */ '/@/core/elements/icons/svgs/caution.vue'
    ),
  chatbubble: () =>
    import(
      /* webpackChunkName: "icon-chatbubble" */ '/@/core/elements/icons/svgs/chatbubble.vue'
    ),
  check: () =>
    import(
      /* webpackChunkName: "icon-check" */ '/@/core/elements/icons/svgs/check.vue'
    ),
  checklist: () =>
    import(
      /* webpackChunkName: "icon-checklist" */ '/@/core/elements/icons/svgs/checklist.vue'
    ),
  chevron: () =>
    import(
      /* webpackChunkName: "icon-chevron" */ '/@/core/elements/icons/svgs/chevron.vue'
    ),
  circle: () =>
    import(
      /* webpackChunkName: "icon-circle" */ '/@/core/elements/icons/svgs/circle.vue'
    ),
  clear: () =>
    import(
      /* webpackChunkName: "icon-clear" */ '/@/core/elements/icons/svgs/clear.vue'
    ),
  close: () =>
    import(
      /* webpackChunkName: "icon-close" */ '/@/core/elements/icons/svgs/close.vue'
    ),
  coins: () =>
    import(
      /* webpackChunkName: "icon-coins" */ '/@/core/elements/icons/svgs/coins.vue'
    ),
  colorwheel: () =>
    import(
      /* webpackChunkName: "icon-colorwheel" */ '/@/core/elements/icons/svgs/colorwheel.vue'
    ),
  comments: () =>
    import(
      /* webpackChunkName: "icon-comments" */ '/@/core/elements/icons/svgs/comments.vue'
    ),
  contactcard: () =>
    import(
      /* webpackChunkName: "icon-contactcard" */ '/@/core/elements/icons/svgs/contactcard.vue'
    ),
  'credit-card': () =>
    import(
      /* webpackChunkName: "icon-credit-card" */ '/@/core/elements/icons/svgs/credit-card.vue'
    ),
  crop: () =>
    import(
      /* webpackChunkName: "icon-crop" */ '/@/core/elements/icons/svgs/crop.vue'
    ),
  delete: () =>
    import(
      /* webpackChunkName: "icon-delete" */ '/@/core/elements/icons/svgs/delete.vue'
    ),
  discounts: () =>
    import(
      /* webpackChunkName: "icon-discounts" */ '/@/core/elements/icons/svgs/discounts.vue'
    ),
  distort: () =>
    import(
      /* webpackChunkName: "icon-distort" */ '/@/core/elements/icons/svgs/distort.vue'
    ),
  dollar: () =>
    import(
      /* webpackChunkName: "icon-dollar" */ '/@/core/elements/icons/svgs/dollar.vue'
    ),
  done: () =>
    import(
      /* webpackChunkName: "icon-done" */ '/@/core/elements/icons/svgs/done.vue'
    ),
  download: () =>
    import(
      /* webpackChunkName: "icon-download" */ '/@/core/elements/icons/svgs/download.vue'
    ),
  dragdots: () =>
    import(
      /* webpackChunkName: "icon-dragdots" */ '/@/core/elements/icons/svgs/dragdots.vue'
    ),
  duplicate: () =>
    import(
      /* webpackChunkName: "icon-duplicate" */ '/@/core/elements/icons/svgs/duplicate.vue'
    ),
  edit: () =>
    import(
      /* webpackChunkName: "icon-edit" */ '/@/core/elements/icons/svgs/edit.vue'
    ),
  editAlt: () =>
    import(
      /* webpackChunkName: "icon-editAlt" */ '/@/core/elements/icons/svgs/editAlt.vue'
    ),
  ellipses: () =>
    import(
      /* webpackChunkName: "icon-ellipses" */ '/@/core/elements/icons/svgs/ellipses.vue'
    ),
  email: () =>
    import(
      /* webpackChunkName: "icon-email" */ '/@/core/elements/icons/svgs/email.vue'
    ),
  eye: () =>
    import(
      /* webpackChunkName: "icon-eye" */ '/@/core/elements/icons/svgs/eye.vue'
    ),
  eyeOff: () =>
    import(
      /* webpackChunkName: "icon-eyeOff" */ '/@/core/elements/icons/svgs/eyeOff.vue'
    ),
  facebook: () =>
    import(
      /* webpackChunkName: "icon-facebook" */ '/@/core/elements/icons/svgs/facebook.vue'
    ),
  faq: () =>
    import(
      /* webpackChunkName: "icon-faq" */ '/@/core/elements/icons/svgs/faq.vue'
    ),
  favorite: () =>
    import(
      /* webpackChunkName: "icon-favorite" */ '/@/core/elements/icons/svgs/favorite.vue'
    ),
  favoriteFull: () =>
    import(
      /* webpackChunkName: "icon-favoriteFull" */ '/@/core/elements/icons/svgs/favoriteFull.vue'
    ),
  feature: () =>
    import(
      /* webpackChunkName: "icon-feature" */ '/@/core/elements/icons/svgs/feature.vue'
    ),
  filter: () =>
    import(
      /* webpackChunkName: "icon-filter" */ '/@/core/elements/icons/svgs/filter.vue'
    ),
  flip: () =>
    import(
      /* webpackChunkName: "icon-flip" */ '/@/core/elements/icons/svgs/flip.vue'
    ),
  flower: () =>
    import(
      /* webpackChunkName: "icon-flower" */ '/@/core/elements/icons/svgs/flower.vue'
    ),
  flowervase: () =>
    import(
      /* webpackChunkName: "icon-flowervase" */ '/@/core/elements/icons/svgs/flowervase.vue'
    ),
  friend: () =>
    import(
      /* webpackChunkName: "icon-friend" */ '/@/core/elements/icons/svgs/friend.vue'
    ),
  gear: () =>
    import(
      /* webpackChunkName: "icon-gear" */ '/@/core/elements/icons/svgs/gear.vue'
    ),
  gif: () =>
    import(
      /* webpackChunkName: "icon-gif" */ '/@/core/elements/icons/svgs/gif.vue'
    ),
  gift: () =>
    import(
      /* webpackChunkName: "icon-gift" */ '/@/core/elements/icons/svgs/gift.vue'
    ),
  go: () =>
    import(
      /* webpackChunkName: "icon-go" */ '/@/core/elements/icons/svgs/go.vue'
    ),
  grid: () =>
    import(
      /* webpackChunkName: "icon-grid" */ '/@/core/elements/icons/svgs/grid.vue'
    ),
  gridview: () =>
    import(
      /* webpackChunkName: "icon-gridview" */ '/@/core/elements/icons/svgs/gridview.vue'
    ),
  group: () =>
    import(
      /* webpackChunkName: "icon-group" */ '/@/core/elements/icons/svgs/group.vue'
    ),
  guidepage: () =>
    import(
      /* webpackChunkName: "icon-guidepage" */ '/@/core/elements/icons/svgs/guidepage.vue'
    ),
  hamburger: () =>
    import(
      /* webpackChunkName: "icon-hamburger" */ '/@/core/elements/icons/svgs/hamburger.vue'
    ),
  help: () =>
    import(
      /* webpackChunkName: "icon-help" */ '/@/core/elements/icons/svgs/help.vue'
    ),
  ideabook: () =>
    import(
      /* webpackChunkName: "icon-ideabook" */ '/@/core/elements/icons/svgs/ideabook.vue'
    ),
  import: () =>
    import(
      /* webpackChunkName: "icon-import" */ '/@/core/elements/icons/svgs/import.vue'
    ),
  info: () =>
    import(
      /* webpackChunkName: "icon-info" */ '/@/core/elements/icons/svgs/info.vue'
    ),
  invoice: () =>
    import(
      /* webpackChunkName: "icon-invoice" */ '/@/core/elements/icons/svgs/invoice.vue'
    ),
  joinSlack: () =>
    import(
      /* webpackChunkName: "icon-joinSlack" */ '/@/core/elements/icons/svgs/joinSlack.vue'
    ),
  kudos: () =>
    import(
      /* webpackChunkName: "icon-kudos" */ '/@/core/elements/icons/svgs/kudos.vue'
    ),
  kudosGiven: () =>
    import(
      /* webpackChunkName: "icon-kudosGiven" */ '/@/core/elements/icons/svgs/kudosGiven.vue'
    ),
  landscape: () =>
    import(
      /* webpackChunkName: "icon-landscape" */ '/@/core/elements/icons/svgs/landscape.vue'
    ),
  layers: () =>
    import(
      /* webpackChunkName: "icon-layers" */ '/@/core/elements/icons/svgs/layers.vue'
    ),
  lightning: () =>
    import(
      /* webpackChunkName: "icon-lightning" */ '/@/core/elements/icons/svgs/lightning.vue'
    ),
  like: () =>
    import(
      /* webpackChunkName: "icon-like" */ '/@/core/elements/icons/svgs/like.vue'
    ),
  line: () =>
    import(
      /* webpackChunkName: "icon-line" */ '/@/core/elements/icons/svgs/line.vue'
    ),
  link: () =>
    import(
      /* webpackChunkName: "icon-link" */ '/@/core/elements/icons/svgs/link.vue'
    ),
  linkedin: () =>
    import(
      /* webpackChunkName: "icon-linkedin" */ '/@/core/elements/icons/svgs/linkedin.vue'
    ),
  location: () =>
    import(
      /* webpackChunkName: "icon-location" */ '/@/core/elements/icons/svgs/location.vue'
    ),
  lock: () =>
    import(
      /* webpackChunkName: "icon-lock" */ '/@/core/elements/icons/svgs/lock.vue'
    ),
  loveletter: () =>
    import(
      /* webpackChunkName: "icon-loveletter" */ '/@/core/elements/icons/svgs/loveletter.vue'
    ),
  magicwand: () =>
    import(
      /* webpackChunkName: "icon-magicwand" */ '/@/core/elements/icons/svgs/magicwand.vue'
    ),
  map: () =>
    import(
      /* webpackChunkName: "icon-map" */ '/@/core/elements/icons/svgs/map.vue'
    ),
  measure: () =>
    import(
      /* webpackChunkName: "icon-measure" */ '/@/core/elements/icons/svgs/measure.vue'
    ),
  move: () =>
    import(
      /* webpackChunkName: "icon-move" */ '/@/core/elements/icons/svgs/move.vue'
    ),
  musicnote: () =>
    import(
      /* webpackChunkName: "icon-musicnote" */ '/@/core/elements/icons/svgs/musicnote.vue'
    ),
  newtab: () =>
    import(
      /* webpackChunkName: "icon-newtab" */ '/@/core/elements/icons/svgs/newtab.vue'
    ),
  notepad: () =>
    import(
      /* webpackChunkName: "icon-notepad" */ '/@/core/elements/icons/svgs/notepad.vue'
    ),
  notifications: () =>
    import(
      /* webpackChunkName: "icon-notifications" */ '/@/core/elements/icons/svgs/notifications.vue'
    ),
  notifications_off: () =>
    import(
      /* webpackChunkName: "icon-notifications_off" */ '/@/core/elements/icons/svgs/notifications_off.vue'
    ),
  openbook: () =>
    import(
      /* webpackChunkName: "icon-openbook" */ '/@/core/elements/icons/svgs/openbook.vue'
    ),
  paintbrush: () =>
    import(
      /* webpackChunkName: "icon-paintbrush" */ '/@/core/elements/icons/svgs/paintbrush.vue'
    ),
  palette: () =>
    import(
      /* webpackChunkName: "icon-palette" */ '/@/core/elements/icons/svgs/palette.vue'
    ),
  person_add: () =>
    import(
      /* webpackChunkName: "icon-person_add" */ '/@/core/elements/icons/svgs/person_add.vue'
    ),
  perspective: () =>
    import(
      /* webpackChunkName: "icon-perspective" */ '/@/core/elements/icons/svgs/perspective.vue'
    ),
  pinned: () =>
    import(
      /* webpackChunkName: "icon-pinned" */ '/@/core/elements/icons/svgs/pinned.vue'
    ),
  plus: () =>
    import(
      /* webpackChunkName: "icon-plus" */ '/@/core/elements/icons/svgs/plus.vue'
    ),
  portfolio: () =>
    import(
      /* webpackChunkName: "icon-portfolio" */ '/@/core/elements/icons/svgs/portfolio.vue'
    ),
  portrait: () =>
    import(
      /* webpackChunkName: "icon-portrait" */ '/@/core/elements/icons/svgs/portrait.vue'
    ),
  print: () =>
    import(
      /* webpackChunkName: "icon-print" */ '/@/core/elements/icons/svgs/print.vue'
    ),
  product: () =>
    import(
      /* webpackChunkName: "icon-product" */ '/@/core/elements/icons/svgs/product.vue'
    ),
  projecteditor: () =>
    import(
      /* webpackChunkName: "icon-projecteditor" */ '/@/core/elements/icons/svgs/projecteditor.vue'
    ),
  rect: () =>
    import(
      /* webpackChunkName: "icon-rect" */ '/@/core/elements/icons/svgs/rect.vue'
    ),
  redo: () =>
    import(
      /* webpackChunkName: "icon-redo" */ '/@/core/elements/icons/svgs/redo.vue'
    ),
  reorder: () =>
    import(
      /* webpackChunkName: "icon-reorder" */ '/@/core/elements/icons/svgs/reorder.vue'
    ),
  replace: () =>
    import(
      /* webpackChunkName: "icon-replace" */ '/@/core/elements/icons/svgs/replace.vue'
    ),
  reset: () =>
    import(
      /* webpackChunkName: "icon-reset" */ '/@/core/elements/icons/svgs/reset.vue'
    ),
  resize: () =>
    import(
      /* webpackChunkName: "icon-resize" */ '/@/core/elements/icons/svgs/resize.vue'
    ),
  'rotate-ccw': () =>
    import(
      /* webpackChunkName: "icon-rotate-ccw" */ '/@/core/elements/icons/svgs/rotate-ccw.vue'
    ),
  'rotate-cw': () =>
    import(
      /* webpackChunkName: "icon-rotate-cw" */ '/@/core/elements/icons/svgs/rotate-cw.vue'
    ),
  ruler: () =>
    import(
      /* webpackChunkName: "icon-ruler" */ '/@/core/elements/icons/svgs/ruler.vue'
    ),
  save: () =>
    import(
      /* webpackChunkName: "icon-save" */ '/@/core/elements/icons/svgs/save.vue'
    ),
  scissors: () =>
    import(
      /* webpackChunkName: "icon-scissors" */ '/@/core/elements/icons/svgs/scissors.vue'
    ),
  scissorsReset: () =>
    import(
      /* webpackChunkName: "icon-scissorsReset" */ '/@/core/elements/icons/svgs/scissorsReset.vue'
    ),
  search: () =>
    import(
      /* webpackChunkName: "icon-search" */ '/@/core/elements/icons/svgs/search.vue'
    ),
  section: () =>
    import(
      /* webpackChunkName: "icon-section" */ '/@/core/elements/icons/svgs/section.vue'
    ),
  share: () =>
    import(
      /* webpackChunkName: "icon-share" */ '/@/core/elements/icons/svgs/share.vue'
    ),
  shop: () =>
    import(
      /* webpackChunkName: "icon-shop" */ '/@/core/elements/icons/svgs/shop.vue'
    ),
  short_check: () =>
    import(
      /* webpackChunkName: "icon-short_check" */ '/@/core/elements/icons/svgs/short_check.vue'
    ),
  sidepanel: () =>
    import(
      /* webpackChunkName: "icon-sidepanel" */ '/@/core/elements/icons/svgs/sidepanel.vue'
    ),
  sign: () =>
    import(
      /* webpackChunkName: "icon-sign" */ '/@/core/elements/icons/svgs/sign.vue'
    ),
  slack: () =>
    import(
      /* webpackChunkName: "icon-slack" */ '/@/core/elements/icons/svgs/slack.vue'
    ),
  sourcerer: () =>
    import(
      /* webpackChunkName: "icon-sourcerer" */ '/@/core/elements/icons/svgs/sourcerer.vue'
    ),
  sparkles: () =>
    import(
      /* webpackChunkName: "icon-sparkles" */ '/@/core/elements/icons/svgs/sparkles.vue'
    ),
  sparklesSelected: () =>
    import(
      /* webpackChunkName: "icon-sparklesSelected" */ '/@/core/elements/icons/svgs/sparklesSelected.vue'
    ),
  spinner: () =>
    import(
      /* webpackChunkName: "icon-spinner" */ '/@/core/elements/icons/svgs/spinner.vue'
    ),
  stack: () =>
    import(
      /* webpackChunkName: "icon-stack" */ '/@/core/elements/icons/svgs/stack.vue'
    ),
  text: () =>
    import(
      /* webpackChunkName: "icon-text" */ '/@/core/elements/icons/svgs/text.vue'
    ),
  thumb: () =>
    import(
      /* webpackChunkName: "icon-thumb" */ '/@/core/elements/icons/svgs/thumb.vue'
    ),
  thumbActive: () =>
    import(
      /* webpackChunkName: "icon-thumbActive" */ '/@/core/elements/icons/svgs/thumbActive.vue'
    ),
  topPick: () =>
    import(
      /* webpackChunkName: "icon-topPick" */ '/@/core/elements/icons/svgs/topPick.vue'
    ),
  'trade-service': () =>
    import(
      /* webpackChunkName: "icon-trade-service" */ '/@/core/elements/icons/svgs/trade-service.vue'
    ),
  transaction: () =>
    import(
      /* webpackChunkName: "icon-transaction" */ '/@/core/elements/icons/svgs/transaction.vue'
    ),
  trash: () =>
    import(
      /* webpackChunkName: "icon-trash" */ '/@/core/elements/icons/svgs/trash.vue'
    ),
  triangle: () =>
    import(
      /* webpackChunkName: "icon-triangle" */ '/@/core/elements/icons/svgs/triangle.vue'
    ),
  trophy: () =>
    import(
      /* webpackChunkName: "icon-trophy" */ '/@/core/elements/icons/svgs/trophy.vue'
    ),
  trumpet: () =>
    import(
      /* webpackChunkName: "icon-trumpet" */ '/@/core/elements/icons/svgs/trumpet.vue'
    ),
  undo: () =>
    import(
      /* webpackChunkName: "icon-undo" */ '/@/core/elements/icons/svgs/undo.vue'
    ),
  unlock: () =>
    import(
      /* webpackChunkName: "icon-unlock" */ '/@/core/elements/icons/svgs/unlock.vue'
    ),
  upload: () =>
    import(
      /* webpackChunkName: "icon-upload" */ '/@/core/elements/icons/svgs/upload.vue'
    ),
  van: () =>
    import(
      /* webpackChunkName: "icon-van" */ '/@/core/elements/icons/svgs/van.vue'
    ),
  video: () =>
    import(
      /* webpackChunkName: "icon-video" */ '/@/core/elements/icons/svgs/video.vue'
    ),
  vizualize: () =>
    import(
      /* webpackChunkName: "icon-vizualize" */ '/@/core/elements/icons/svgs/vizualize.vue'
    ),
  website: () =>
    import(
      /* webpackChunkName: "icon-website" */ '/@/core/elements/icons/svgs/website.vue'
    ),
  wizardhat: () =>
    import(
      /* webpackChunkName: "icon-wizardhat" */ '/@/core/elements/icons/svgs/wizardhat.vue'
    ),
  x: () =>
    import(
      /* webpackChunkName: "icon-x" */ '/@/core/elements/icons/svgs/x.vue'
    ),
  zoomIn: () =>
    import(
      /* webpackChunkName: "icon-zoomIn" */ '/@/core/elements/icons/svgs/zoomIn.vue'
    ),
  zoomOut: () =>
    import(
      /* webpackChunkName: "icon-zoomOut" */ '/@/core/elements/icons/svgs/zoomOut.vue'
    ),
  'blobs/blob1': () =>
    import(
      /* webpackChunkName: "icon-blobs/blob1" */ '/@/core/elements/icons/svgs/blobs/blob1.vue'
    ),
  'blobs/blob2': () =>
    import(
      /* webpackChunkName: "icon-blobs/blob2" */ '/@/core/elements/icons/svgs/blobs/blob2.vue'
    ),
  'blobs/blob3': () =>
    import(
      /* webpackChunkName: "icon-blobs/blob3" */ '/@/core/elements/icons/svgs/blobs/blob3.vue'
    ),
  'blobs/blob4': () =>
    import(
      /* webpackChunkName: "icon-blobs/blob4" */ '/@/core/elements/icons/svgs/blobs/blob4.vue'
    ),
  'layers/bringforward': () =>
    import(
      /* webpackChunkName: "icon-layers/bringforward" */ '/@/core/elements/icons/svgs/layers/bringforward.vue'
    ),
  'layers/bringtofront': () =>
    import(
      /* webpackChunkName: "icon-layers/bringtofront" */ '/@/core/elements/icons/svgs/layers/bringtofront.vue'
    ),
  'layers/sendbackward': () =>
    import(
      /* webpackChunkName: "icon-layers/sendbackward" */ '/@/core/elements/icons/svgs/layers/sendbackward.vue'
    ),
  'layers/sendtoback': () =>
    import(
      /* webpackChunkName: "icon-layers/sendtoback" */ '/@/core/elements/icons/svgs/layers/sendtoback.vue'
    ),
  'social/instagram': () =>
    import(
      /* webpackChunkName: "icon-social/instagram" */ '/@/core/elements/icons/svgs/social/instagram.vue'
    ),
  'social/pinterest': () =>
    import(
      /* webpackChunkName: "icon-social/pinterest" */ '/@/core/elements/icons/svgs/social/pinterest.vue'
    ),
  'social/tiktok': () =>
    import(
      /* webpackChunkName: "icon-social/tiktok" */ '/@/core/elements/icons/svgs/social/tiktok.vue'
    ),
  'social/twitter': () =>
    import(
      /* webpackChunkName: "icon-social/twitter" */ '/@/core/elements/icons/svgs/social/twitter.vue'
    ),
  'social/youtube': () =>
    import(
      /* webpackChunkName: "icon-social/youtube" */ '/@/core/elements/icons/svgs/social/youtube.vue'
    ),
}
